export default "__VITE_ASSET__00f2f566__"